import { instance, systemApi } from '@/axios-instance.js'

let currentToken = null

export const setAuthToken = token => {
  currentToken = token || null
  if (currentToken) {
    const header = `Bearer ${currentToken}`
    instance.defaults.headers.common.Authorization = header
    systemApi.defaults.headers.common.Authorization = header
  } else {
    delete instance.defaults.headers.common.Authorization
    delete systemApi.defaults.headers.common.Authorization
  }
}

export const getAuthToken = () => currentToken

export const readTokenFromCookie = cookieString => {
  if (!cookieString) return null
  const parts = String(cookieString).split(';')
  for (const part of parts) {
    const [rawKey, ...rawValue] = part.trim().split('=')
    if (rawKey === 'token') {
      return decodeURIComponent(rawValue.join('='))
    }
  }
  return null
}

export const getTokenFromHeaders = headers =>
  readTokenFromCookie(headers?.cookie || headers?.Cookie || '')

export const setAuthCookie = token => {
  if (typeof document === 'undefined') return
  if (!token) {
    document.cookie = 'token=; Path=/; Max-Age=0; SameSite=Lax'
    return
  }
  document.cookie = `token=${encodeURIComponent(token)}; Path=/; SameSite=Lax`
}
